import script from "./JaContentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentPreview.vue?vue&type=script&setup=true&lang=js"

import "./JaContentPreview.vue?vue&type=style&index=0&id=811865b6&scoped=true&lang=css"
import "./JaContentPreview.vue?vue&type=style&index=1&id=811865b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-811865b6"]])

export default __exports__